import { FaPaperPlane } from "react-icons/fa";
import EAIHero from "../../assets/service/eai1.png";

import React from "react";

const OurWorkingProcess = () => {
  const steps = [
    {
      id: 1,
      title: "Design",
      description:
        "We focus on the best practices for IT solutions and services.",
      image: EAIHero,
      color: "bg-pink",
    },
    {
      id: 2,
      title: "Testing",
      description: "We ensure high-quality standards and smooth performance.",
      image: EAIHero,
      color: "bg-blue-900",
    },
    {
      id: 3,
      title: "Go-Live",
      description: "We make sure your project is ready for the real world.",
      image: EAIHero,
      color: "bg-pink",
    },
  ];
  return (
    <div className="w-full bg-white py-16 px-4 sm:px-6 lg:px-20">
      <div className="text-center mb-12">
        <h2 className="text-pink font-semibold tracking-wider uppercase text-sm relative inline-block after:absolute after:w-full after:h-[2px] after:bg-pink-500 after:left-0 after:-bottom-1 after:rounded-full after:opacity-40">
          Work Process
        </h2>
        <h1 className="text-4xl font-bold text-gray-800 mt-4">
          Our Working Process
        </h1>
      </div>

      <div className="relative max-w-7xl mx-auto">
        {/* Dashed Curve Line */}
        <svg
          className="absolute left-0 top-1/3 -translate-y-1/2 w-full hidden sm:block"
          height="120"
          viewBox="0 0 1000 120"
          preserveAspectRatio="none"
        >
          <path
            d="M0,60 C250,0 750,120 1000,60"
            stroke="#E5E7EB"
            strokeWidth="2"
            strokeDasharray="10,10"
            fill="none"
          />
        </svg>

        {/* Paper Plane */}
        <FaPaperPlane className="hidden sm:block absolute right-0 top-[35%] transform translate-x-8 -translate-y-6 text-pink text-2xl rotate-12" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-y-12 sm:gap-y-0">
          {steps.map((step) => (
            <div
              key={step.id}
              className="flex flex-col items-center cursor-pointer text-center max-w-xs mx-auto hover:scale-105 transition-transform duration-300"
            >
              <div className="relative mb-4 w-36 h-36 rounded-full shadow-lg overflow-hidden">
                <img
                  src={step.image}
                  alt={step.title}
                  className="w-full h-full object-cover"
                />
                <div
                  className={`absolute bottom-2 right-4 w-9 h-9 ${step.color} text-white text-sm font-bold rounded-full flex items-center justify-center shadow-md border-2 border-white`}
                >
                  {String(step.id).padStart(2, "0")}
                </div>
              </div>

              <h3 className="text-lg font-semibold text-gray-700 mb-1">
                {step.title}
              </h3>
              <p className="text-gray-500 text-sm">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OurWorkingProcess;
